import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();

    delete window.axios?.defaults?.headers?.common["Authorization"];

    toast.success("Logged out successfully");

    navigate("/login", { replace: true });
  }, [navigate]);

  return null; // component render nahi karega, sirf redirect
};

export default Logout;
